import {ValueObject} from '@s-ui/domain'

export class EquipmentValueObject extends ValueObject {
  /**
   * @param {Object} params
   * @param {Array} params.standard
   * @param {Array} params.optional
   * */
}
